/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";

/**
 * 包含待编码文本 'text' 的JSON对象
 */
export type PostTextBase64EncodeRequest = { text: string };

export const PostTextBase64EncodeRequest$zodSchema: z.ZodType<
  PostTextBase64EncodeRequest
> = z.object({
  text: z.string(),
}).describe("包含待编码文本 'text' 的JSON对象");

export type PostTextBase64EncodeDetails = {};

export const PostTextBase64EncodeDetails$zodSchema: z.ZodType<
  PostTextBase64EncodeDetails
> = z.object({});

/**
 * 无效的请求参数
 */
export type PostTextBase64EncodeBadRequestResponseBody = {
  code?: string | undefined;
  details?: PostTextBase64EncodeDetails | undefined;
  message?: string | undefined;
};

export const PostTextBase64EncodeBadRequestResponseBody$zodSchema: z.ZodType<
  PostTextBase64EncodeBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  details: z.lazy(() => PostTextBase64EncodeDetails$zodSchema).optional(),
  message: z.string().optional(),
}).describe("无效的请求参数");

/**
 * 成功响应
 */
export type PostTextBase64EncodeResponseBody = { encoded?: string | undefined };

export const PostTextBase64EncodeResponseBody$zodSchema: z.ZodType<
  PostTextBase64EncodeResponseBody
> = z.object({
  encoded: z.string().optional(),
}).describe("成功响应");

export type PostTextBase64EncodeResponse =
  | PostTextBase64EncodeResponseBody
  | PostTextBase64EncodeBadRequestResponseBody;

export const PostTextBase64EncodeResponse$zodSchema: z.ZodType<
  PostTextBase64EncodeResponse
> = z.union([
  z.lazy(() => PostTextBase64EncodeResponseBody$zodSchema),
  z.lazy(() => PostTextBase64EncodeBadRequestResponseBody$zodSchema),
]);
